module.exports = __webpack_public_path__ + "img/deptInfo.c74b8488.png";